import { AdminTopbar } from "@/components/admin/AdminLayout";
import { ModulePanel } from "@/components/admin/AdminPrimitives";
import { useI18n } from "@/lib/i18n";

function Security() {
  const { t } = useI18n();

  const CHECKS = [
    t("admin.security.check.1"),
    t("admin.security.check.2"),
    t("admin.security.check.3"),
    t("admin.security.check.4"),
    t("admin.security.check.5"),
  ];

  return (
    <>
      <AdminTopbar title={t("admin.security.title")} subtitle={t("admin.security.subtitle")} />
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        <ModulePanel
          title={t("admin.security.checklist")}
          description={t("admin.security.checklistDesc")}
        >
          <ul className="space-y-3">
            {CHECKS.map((c, i) => (
              <li key={i} className="flex items-start gap-3 rounded-md border border-border bg-surface p-3">
                <input type="checkbox" defaultChecked={i < 2} className="mt-1 h-4 w-4 rounded border-border" />
                <div className="flex-1 text-sm">
                  <div className="font-medium text-foreground">{c}</div>
                  <div className="text-xs text-muted-foreground">{t("admin.security.reviewerNote")}</div>
                </div>
              </li>
            ))}
          </ul>
          <div className="mt-5 flex items-center gap-3">
            <button className="rounded-md bg-verified px-4 py-2 text-xs font-semibold text-verified-foreground">
              {t("admin.security.approve")}
            </button>
            <button className="rounded-md border border-alert px-4 py-2 text-xs font-semibold text-alert">
              {t("admin.security.block")}
            </button>
          </div>
        </ModulePanel>
      </div>
    </>
  );
}

export default Security;
